<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import PharmacySearch from '../PharmacySearch/PharmacySearch.svelte';
  import PharmacyTile from '../PharmacyTile/PharmacyTile.svelte';
  import BaseMarkdown from '../BaseMarkdown/BaseMarkdown.svelte';
  import SearchPromoLite from '../SearchPromoLite/SearchPromoLite.svelte';

  let {
    headingTextTemplate,
    headingLevel = 'h2',
    descriptionTemplate,
    pharmacyLimit = 20,
    locationsTemplate,
    singleLocationTemplate,
    pharmacySearch,
    featuredPharmaciesLabel,
    baseMarkdown,
    searchPromoLite,
    dataTestId = 'extended-pharmacies',
    count,
    pharmacies,
    filters,
  } = $props();
</script>

<section class="mx-auto max-w-6xl" data-testid={dataTestId}>
  {#if isNaN(count) || count > 1}
    <div class="px-4 mb-2 md:mb-4 md:px-4">
      <BaseHeading
        {headingLevel}
        className="text-blue-dark-navy font-semibold text-lg lg:text-1.5xl leading-tight mb-2 lg:mb-4"
      >
        {headingTextTemplate}
      </BaseHeading>
      {#if descriptionTemplate}
        {@html descriptionTemplate}
      {/if}
    </div>
    {#if pharmacySearch}<PharmacySearch {...pharmacySearch} {filters} parentComponent='extendedPharmacyList' />{/if}
    {#if pharmacies}
      {#if featuredPharmaciesLabel}
        <h3 class="text-blue-dark-navy text-lg mt-8 px-4">{featuredPharmaciesLabel}</h3>
      {/if}
      <div class="px-4 pt-4 lg:flex lg:items-start lg:justify-between">
        <div
          class="grid grid-cols-2 w-full sm:grid-cols-4 lg:grid-cols-4 gap-4 sm:gap-6 sm:mb-4"
          class:md:grid-cols-4={pharmacies.length < 12}
          class:lg:grid-cols-5={pharmacies.length < 12}
        >
          {#each pharmacies.slice(0, pharmacyLimit < 12 ? pharmacyLimit : 12) as { name, image, link, showLogo, isNew, count }, index (index)}
            <PharmacyTile
              {name}
              {image}
              {link}
              {showLogo}
              {isNew}
              {index}
              {count}
              {locationsTemplate}
              {singleLocationTemplate}
            />
          {/each}
        </div>
        {#if pharmacies.length > 12}
          <div class="mt-4 sm:mt-8 lg:mt-0">
            <ul class="w-full sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-4 lg:block lg:pl-8">
              {#each pharmacies.slice(12, pharmacyLimit) as { name, link, count }, index (index)}
                <li dataTestId="{dataTestId}-list-item-{index}">
                  <BaseLink
                    {...link}
                    className={`flex justify-between items-baseline w-full px-4 shadow-y-sm bg-white py-4 lg:py-3 text-blue-navy leading-tight lg:min-w-88
                    hover-hover:hover:text-blue-cerulean active:text-blue-cerulean active:shadow-inset-active focus:outline-hidden focus:shadow-inset-focus lg:mb-px ${
                      count ? 'text-base font-semibold' : 'text-lg'
                    }`}
                  >
                    {name}
                    {#if count}
                      {#if count === 1 && singleLocationTemplate}
                        <span class="text-gray-charcoal text-sm shrink-0 pl-2 font-normal">
                          {singleLocationTemplate.replace(/{{COUNT}}/, count)}
                        </span>
                      {:else}
                        <span class="text-gray-charcoal text-sm shrink-0 pl-2 font-normal">
                          {locationsTemplate.replace(/{{COUNT}}/, count)}
                        </span>
                      {/if}
                    {/if}
                  </BaseLink>
                </li>
              {/each}
            </ul>
          </div>
        {/if}
      </div>
    {/if}
  {/if}
  {#if baseMarkdown}
    <div class="flex justify-center text-center">
      <div class="max-w-2xl w-full">
        <BaseMarkdown {...baseMarkdown} simpleStyles="true" />
        <SearchPromoLite {...searchPromoLite} noHeading="true" />
      </div>
    </div>
  {/if}
</section>
